
import { supabase } from "@/integrations/supabase/client";

interface Newsletter {
  subject: string;
  content: string;
  headerImage?: string;
}

export const sendNewsletter = async (newsletter: Newsletter) => {
  try {
    console.log("Sending newsletter:", newsletter);
    
    const { data, error } = await supabase.functions.invoke("send-newsletter", {
      body: { newsletter },
    });

    if (error) {
      console.error("Error sending newsletter:", error);
      return { success: false, error: error.message };
    }

    // If we have an error message in the response data
    if (data?.error) {
      console.error("Error in send-newsletter function:", data.error);
      return { success: false, error: data.error };
    }

    console.log("Newsletter sent successfully:", data);
    return { success: true, data };
  } catch (err) {
    console.error("Exception sending newsletter:", err);
    return { success: false, error: err instanceof Error ? err.message : "Unknown error" };
  }
};
